// extracted by mini-css-extract-plugin
module.exports = {"returnsWrapper":"returns_returnsWrapper___eSXE"};